import { createSelector } from 'reselect';
import { getProfileData } from './getProfileData';
// import { getLangSuffix } from '@src/containers/Session/selectors/getLangSuffix';
// import { getProfileId } from './getProfileId';
// import { getCitySlug } from '@src/containers/Session/selectors/getCitySlug';
// import { getLocale } from '@src/containers/Session/selectors/getLocale';

export const getFuncAlbums = createSelector(
	getProfileData,
	// getCitySlug,
	// getLangSuffix,
	// getProfileId,
	// getLocale,
	(data) => {
		const url = data.url ? new URL(data.url).pathname : '';
		const albums = (data?.album || []).filter((a) => !a.isWedding);
		return { albums, url };
	},
);
